export default "__VITE_ASSET__Dom0IJnt__"